const getters = {
    sidebar: state => state.app.sidebar,
    token: state => state.user.token,
    name: state => state.user.name,
    avatar: state => state.user.avatar,
    employeeId: state => state.user.employeeId,
    userName: state => state.user.userName,
    roles: state => state.user.roles,
    scope: state => state.user.scope,
    deptId: state => state.user.deptId,
    deptName: state => state.user.deptName,
    userId: state => state.user.userId,
    permissions: state => state.user.permissions,
    permission_routes: state => state.permission.routes,
    topbarRouters:state => state.permission.topbarRouters,
    defaultRoutes:state => state.permission.defaultRoutes,
    sidebarRouters:state => state.permission.sidebarRouters,
    dict: state => state.dict.dict,
}

export default getters